import { render, staticRenderFns } from "./addLiveClass.vue?vue&type=template&id=36ea9e28"
import script from "./addLiveClass.vue?vue&type=script&lang=js"
export * from "./addLiveClass.vue?vue&type=script&lang=js"
import style1 from "./addLiveClass.vue?vue&type=style&index=1&id=36ea9e28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports